import React from 'react';
import { observer } from 'mobx-react-lite';

import CustomModal from 'components/CustomModal';
import { Button } from 'components/Button';
import CustomUserDropdownField from 'components/SharedFormComponents/CustomUserDropdownField/CustomUserDropdownField';
import { useStore } from 'utils/hooks/store';
import { UuidableName } from 'utils/api/types';

interface TransferOwnershipModalProps {
  open: boolean;
  onClose: () => void;
}

const TransferOwnershipModal: React.FC<TransferOwnershipModalProps> = observer(({ open, onClose }) => {
  const { documentsDetails } = useStore();

  const [transferring, setTransferring] = React.useState(false);
  const [selectedNewOwner, setSelectedNewOwner] = React.useState<UuidableName | null>(null);

  const handleClose = (): void => {
    setSelectedNewOwner(null);
    onClose();
  };

  const handleTransfer = async (): Promise<void> => {
    if (!selectedNewOwner) return;
    setTransferring(true);
    const success = await documentsDetails.transferOwnership(selectedNewOwner.uuid);
    setTransferring(false);
    if (success) handleClose();
  };

  return (
    <CustomModal
      openModal={open}
      modalTitle="Transfer ownership"
      modalDescription="Select the person to make the new owner of this document."
      onClose={handleClose}
      modalWidth="xs"
      cancelButton={
        <Button variant="outlined" size="large" onClick={handleClose}>
          Cancel
        </Button>
      }
      submitButton={
        <Button variant="contained" size="large" onClick={handleTransfer} disabled={!selectedNewOwner || transferring}>
          {transferring ? 'Transferring...' : 'Transfer'}
        </Button>
      }
    >
      <CustomUserDropdownField
        value={selectedNewOwner}
        onChange={(value) => setSelectedNewOwner(value as UuidableName | null)}
        requiredNotFilled={false}
        description=""
        disableInitialLoad
        licenses="documents"
      />
    </CustomModal>
  );
});

export default TransferOwnershipModal;
